var React = require('react');

function ParabolicShapeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M160 0c58.863 0 112.196 4 160 12H0C47.804 4 101.137 0 160 0z"}));
}

ParabolicShapeInline.defaultProps = {"viewBox":"0 0 320 12","className":"parabolic-shape","preserveAspectRatio":"none"};

module.exports = ParabolicShapeInline;

ParabolicShapeInline.default = ParabolicShapeInline;
